import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'blank',
  name: '空白',
  icon: '空',
  group: '辅助组件',
  description: '增加组件之间的垂直间距',
  defaultProps: {
    height: 24
  }
}
